import type { IconButtonSize } from './types'

/**
 * Сторона кнопки по size. Из макета §20 контейнер 44×44 — это M.
 * Для S/L точных токенов нет (control-height-s/l — 44/52, ближе к M/L),
 * S=36 — задокументированное отклонение спеки (компактный вариант, напр. в строке тулбара).
 *
 * XS=24 — кнопка размером почти с сам глиф. Нужна там, где кнопку ставят В УГОЛ блока:
 * у коробки 44×44 глиф сидит в её центре, то есть в 22px от края, и в невысокой карточке
 * крестик оказывается по середине текста, а не в углу (правка основателя по совету на
 * полотне уз). Зона нажатия при этом остаётся 44×44 — её добирает миксин `tap-target`
 * псевдоэлементом, наружу от коробки, и на раскладку она не влияет.
 */
export const ICON_BUTTON_SIZE: Record<IconButtonSize, string> = {
  XS: '24px',
  S: '36px',
  M: 'var(--control-height-s)',
  L: 'var(--control-height-l)',
}

/** Размер самой иконки внутри кнопки — из макета §20: 17px у M. */
export const ICON_BUTTON_ICON_SIZE: Record<IconButtonSize, number> = {
  XS: 14,
  S: 15,
  M: 17,
  L: 20,
}
